export default __webpack_public_path__ + "media/images/brighteon-social/Icon-SignOut-Gray-62ba269b6fa9a00ecee73cf6b5066345.svg";